import { combineReducers } from '@reduxjs/toolkit';
import app from './app';
import user from './user';
import routesData from './routes';
import loader from './loader';
import route from './route';
import notifications from './notifications';
import schedule from './schedule';
import map from './map';
import ui from './ui';
import modal from './modal';
import sectionsData from './sections';

export default combineReducers({
  map,
  app,
  user,
  routesData,
  loader,
  route,
  notifications,
  schedule,
  ui,
  modal,
  sectionsData,
});
